import { render, staticRenderFns } from "./PeoplePage.vue?vue&type=template&id=cf32d732"
import script from "./PeoplePage.vue?vue&type=script&lang=js"
export * from "./PeoplePage.vue?vue&type=script&lang=js"
import style0 from "./PeoplePage.vue?vue&type=style&index=0&id=cf32d732&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports